import React, { useEffect, useState } from "react";
import Header from "../general/Header";
import Aside from "../general/Aside";
import Footer from "../general/Footer";
import axios from "../../axios/axiosconf";
import Loading from "../general/Loading";
import Unauthorized from "../general/Unauthorized";
import { Link, useHistory } from "react-router-dom";
import { Modal } from "react-bootstrap";
import { formatearFecha, formatearMoneda } from "./liquidacionProfesionalPrint";
import ModalLiquidacionHonorarios from "./ModalLiquidacionHonorarios";
import { ymdLocal } from "../../../resources/Helper";
import { resolverProveedorDesdeLiquidacion } from "../../../utils/liquidacionHonorariosFacturacion";

const tienePermiso = (userdata) => {
    if (userdata.permissions && Array.isArray(userdata.permissions)) {
        return userdata.permissions.some((p) => p.slug === "verReportes" || p.slug === "ver_listado_facturas");
    }
    return userdata.up && (userdata.up.includes("verReportes") || userdata.up.includes("ver_listado_facturas"));
};

const badgeEstado = (estado) => {
    if (estado === "anulada") {
        return { bg: "#fef2f2", color: "#b91c1c", border: "#fecaca", label: "Anulada" };
    }
    return { bg: "#ecfdf5", color: "#047857", border: "#a7f3d0", label: "Aprobada" };
};

const textoPeriodoLiquidacion = (row) =>
    `${formatearFecha(row?.fecha_inicio)} — ${formatearFecha(row?.fecha_fin)}`;

const filtrosInicialesMes = () => {
    const hoy = new Date();
    const inicioMes = new Date(hoy.getFullYear(), hoy.getMonth(), 1);
    return {
        fechaInicio: ymdLocal(inicioMes),
        fechaFin: ymdLocal(hoy),
        usersId: "",
        estado: "",
    };
};

function ListadoLiquidacionProfesional() {
    const [loggedIn, setLoggedIn] = useState(false);
    const [hasPermission, setHasPermission] = useState(false);
    const [client, setClient] = useState([]);
    const [usuarios, setUsuarios] = useState([]);
    const [listado, setListado] = useState([]);
    const [loading, setLoading] = useState(false);
    const [msg, setMsg] = useState("");
    const [filtros, setFiltros] = useState(filtrosInicialesMes);
    const [modalAnular, setModalAnular] = useState({ visible: false, row: null });
    const [motivoAnulacion, setMotivoAnulacion] = useState("");
    const [fechaAnulacion, setFechaAnulacion] = useState("");
    const [anulando, setAnulando] = useState(false);
    const [modalImpresion, setModalImpresion] = useState({ visible: false, data: null });
    const [modalAcciones, setModalAcciones] = useState({ visible: false, row: null });
    const [generandoDoc, setGenerandoDoc] = useState(false);
    const history = useHistory();

    const cargarListado = (params = filtros) => {
        setLoading(true);
        setMsg("");
        const q = {};
        if (params.fechaInicio) q.fecha_inicio = params.fechaInicio;
        if (params.fechaFin) q.fecha_fin = params.fechaFin;
        if (params.usersId) q.users_id = params.usersId;
        if (params.estado) q.estado = params.estado;

        axios.get("/liquidacion-profesional", { params: q })
            .then((r) => setListado(Array.isArray(r.data) ? r.data : []))
            .catch((err) => {
                setListado([]);
                setMsg(err.response?.data?.message || "No se pudo cargar el listado.");
            })
            .finally(() => setLoading(false));
    };

    useEffect(() => {
        if (!localStorage.getItem("userdata")) {
            setHasPermission(false);
            setLoggedIn(true);
            return;
        }
        const userdata = JSON.parse(localStorage.getItem("userdata"));
        if (!tienePermiso(userdata)) {
            setHasPermission(false);
            setLoggedIn(true);
            return;
        }
        setHasPermission(true);

        const fInit = filtrosInicialesMes();
        setFiltros(fInit);

        Promise.all([
            axios.get("/get-client?uid=" + userdata.user_id),
            axios.get("/users-by-client?uid=" + userdata.user_id),
        ])
            .then(([cRes, uRes]) => {
                if (cRes?.data) setClient(cRes.data);
                setUsuarios(uRes.data || []);
                cargarListado(fInit);
                setLoggedIn(true);
            })
            .catch(() => setLoggedIn(true));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const verDetalle = (id) => {
        axios.get(`/liquidacion-profesional/${id}`)
            .then((r) => {
                if (r.data) setModalImpresion({ visible: true, data: r.data });
            })
            .catch((err) => {
                alert(err.response?.data?.message || "No se pudo cargar la liquidación.");
            });
    };

    const abrirModalAnular = (row) => {
        if (row.estado === "anulada") return;
        setMotivoAnulacion("");
        setFechaAnulacion(ymdLocal());
        setModalAnular({ visible: true, row });
    };

    const abrirModalAcciones = (row) => {
        setModalAcciones({ visible: true, row });
    };

    const cerrarModalAcciones = () => {
        setModalAcciones({ visible: false, row: null });
    };

    const accionImprimir = () => {
        const row = modalAcciones.row;
        if (!row) return;
        cerrarModalAcciones();
        verDetalle(row.id);
    };

    const accionAnular = () => {
        const row = modalAcciones.row;
        if (!row || row.estado === "anulada") return;
        cerrarModalAcciones();
        abrirModalAnular(row);
    };

    const navegarConProveedorLiquidacion = async (destino, liquidacion) => {
        if (!liquidacion || liquidacion.estado === "anulada") {
            alert("No se puede generar documento desde una liquidación anulada.");
            return;
        }
        setGenerandoDoc(true);
        try {
            const pref = await resolverProveedorDesdeLiquidacion(liquidacion);
            cerrarModalAcciones();
            setModalImpresion({ visible: false, data: null });
            history.push({
                pathname: destino,
                state: { fromLiquidacion: true, ...pref },
            });
        } catch (err) {
            console.error(err);
            const msgErr =
                err?.response?.data?.message ||
                err?.response?.data?.error ||
                err?.message ||
                "No se pudo preparar el proveedor.";
            alert(msgErr);
        } finally {
            setGenerandoDoc(false);
        }
    };

    const accionGenerarEgreso = () => {
        const row = modalAcciones.row;
        if (!row) return;
        navegarConProveedorLiquidacion("/crear-egreso", row);
    };

    const accionGenerarDocumentoSoporte = () => {
        const row = modalAcciones.row;
        if (!row) return;
        navegarConProveedorLiquidacion("/crear-documento-soporte", row);
    };

    const cerrarModalAnular = () => {
        if (anulando) return;
        setModalAnular({ visible: false, row: null });
        setMotivoAnulacion("");
        setFechaAnulacion("");
    };

    const confirmarAnular = () => {
        const row = modalAnular.row;
        if (!row) return;
        const motivo = String(motivoAnulacion || "").trim();
        if (!motivo) {
            alert("Debe indicar el motivo de anulación.");
            return;
        }
        setAnulando(true);
        axios.post(`/liquidacion-profesional/${row.id}/anular`, {
            motivo_anulacion: motivo,
            fecha_anulacion: fechaAnulacion || null,
        })
            .then(() => {
                setMsg("Liquidación anulada.");
                setModalAnular({ visible: false, row: null });
                setMotivoAnulacion("");
                setFechaAnulacion("");
                cargarListado();
            })
            .catch((err) => {
                const errs = err.response?.data?.errors;
                if (errs?.motivo_anulacion) {
                    alert(errs.motivo_anulacion[0]);
                } else {
                    alert(err.response?.data?.message || "No se pudo anular.");
                }
            })
            .finally(() => setAnulando(false));
    };

    const limpiarFiltros = () => {
        const fInit = filtrosInicialesMes();
        setFiltros(fInit);
        cargarListado(fInit);
    };

    if (hasPermission === false) return <Unauthorized />;
    if (!loggedIn) return <Loading />;

    return (
        <div className="wrapper hold-transition liq-prof-page" style={{ fontSize: "13px" }}>
            <Header client={client} />
            <Aside client={client} activelink="reports" />
            <div className="content-wrapper">
                <div className="content-header">
                    <div className="container-fluid">
                        <div className="row align-items-center">
                            <div className="col">
                                <ol className="breadcrumb float-sm-left mb-1">
                                    <li className="breadcrumb-item"><Link to="/home">Home</Link></li>
                                    <li className="breadcrumb-item"><Link to="/estadisticas">Reportes</Link></li>
                                    <li className="breadcrumb-item"><Link to="/estadisticas-contables">Contables</Link></li>
                                    <li className="breadcrumb-item active">Liquidaciones profesional</li>
                                </ol>
                              
                            </div>
                            <div className="col-auto">
                                <Link to="/liquidar-profesional" className="btn btn-success btn-sm">
                                    <i className="fas fa-plus mr-1"></i> Nueva liquidación
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>

                <section className="content">
                    <div className="container-fluid">
                        {msg && <div className="alert alert-info py-2">{msg}</div>}

                        <div className="card liq-prof-card mb-3">
                            <div className="card-body py-3">
                                <div className="row liq-prof-filters align-items-end g-2">
                                    <div className="col-lg-2 col-md-4 col-6">
                                        <label htmlFor="liqFechaInicio">Fecha inicio</label>
                                        <input
                                            id="liqFechaInicio"
                                            type="date"
                                            className="form-control form-control-sm"
                                            value={filtros.fechaInicio}
                                            onChange={(e) => setFiltros((f) => ({ ...f, fechaInicio: e.target.value }))}
                                        />
                                    </div>
                                    <div className="col-lg-2 col-md-4 col-6">
                                        <label htmlFor="liqFechaFin">Fecha fin</label>
                                        <input
                                            id="liqFechaFin"
                                            type="date"
                                            className="form-control form-control-sm"
                                            value={filtros.fechaFin}
                                            onChange={(e) => setFiltros((f) => ({ ...f, fechaFin: e.target.value }))}
                                        />
                                    </div>
                                    <div className="col-lg-3 col-md-4">
                                        <label htmlFor="liqProfesional">Profesional</label>
                                        <select
                                            id="liqProfesional"
                                            className="form-control form-control-sm"
                                            value={filtros.usersId}
                                            onChange={(e) => setFiltros((f) => ({ ...f, usersId: e.target.value }))}
                                        >
                                            <option value="">Todos</option>
                                            {usuarios.map((u) => (
                                                <option key={u.id} value={u.id}>{u.name}</option>
                                            ))}
                                        </select>
                                    </div>
                                    <div className="col-lg-2 col-md-4">
                                        <label htmlFor="liqEstado">Estado</label>
                                        <select
                                            id="liqEstado"
                                            className="form-control form-control-sm"
                                            value={filtros.estado}
                                            onChange={(e) => setFiltros((f) => ({ ...f, estado: e.target.value }))}
                                        >
                                            <option value="">Todos</option>
                                            <option value="aprobada">Aprobada</option>
                                            <option value="anulada">Anulada</option>
                                        </select>
                                    </div>
                                    <div className="col-lg-auto col-md-4">
                                        <label className="d-none d-lg-block">&nbsp;</label>
                                        <div className="d-flex align-items-center" style={{ gap: "6px" }}>
                                            <button
                                                type="button"
                                                className="btn btn-primary btn-sm px-2"
                                                onClick={() => cargarListado()}
                                                disabled={loading}
                                                title="Buscar"
                                            >
                                                <i className="fas fa-search"></i>
                                            </button>
                                            <button
                                                type="button"
                                                className="btn btn-outline-secondary btn-sm px-2"
                                                onClick={limpiarFiltros}
                                                disabled={loading}
                                                title="Limpiar filtros"
                                            >
                                                <i className="fas fa-trash-alt"></i>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="card liq-prof-table-card">
                            <div className="card-body p-0">
                                <div className="table-responsive">
                                    <table className="table custom-table mb-0">
                                        <thead>
                                            <tr>
                                                <th>Profesional</th>
                                                <th>Período</th>
                                                <th className="text-right">Valor total</th>
                                                <th className="text-center">Estado</th>
                                                <th>Registrada</th>
                                                <th>Motivo anulación</th>
                                                <th className="text-center">Acciones</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {listado.length ? listado.map((row) => {
                                                const est = badgeEstado(row.estado);
                                                return (
                                                    <tr key={row.id} className={row.estado === "anulada" ? "text-muted" : ""}>
                                                        <td>{row.profesional_nombre}</td>
                                                        <td>{textoPeriodoLiquidacion(row)}</td>
                                                        <td className="text-right"><strong>{formatearMoneda(row.valor_total)}</strong></td>
                                                        <td className="text-center">
                                                            <span
                                                                className="badge"
                                                                style={{
                                                                    background: est.bg,
                                                                    color: est.color,
                                                                    border: `1px solid ${est.border}`,
                                                                    borderRadius: "999px",
                                                                    fontWeight: 700,
                                                                }}
                                                            >
                                                                {est.label}
                                                            </span>
                                                        </td>
                                                        <td>{formatearFecha(row.created_at)}</td>
                                                        <td className="liq-motivo-cell">
                                                            {row.estado === "anulada" && row.motivo_anulacion ? (
                                                                <>
                                                                    <span title={row.motivo_anulacion}>{row.motivo_anulacion}</span>
                                                                    {row.fecha_anulacion && (
                                                                        <small className="d-block text-muted">
                                                                            {formatearFecha(row.fecha_anulacion)}
                                                                        </small>
                                                                    )}
                                                                </>
                                                            ) : (
                                                                <span className="text-muted">—</span>
                                                            )}
                                                        </td>
                                                        <td className="text-center">
                                                            <button
                                                                type="button"
                                                                className="btn btn-sm liq-icon-btn liq-icon-btn--menu"
                                                                title="Opciones"
                                                                onClick={() => abrirModalAcciones(row)}
                                                            >
                                                                <i className="fas fa-ellipsis-h"></i>
                                                            </button>
                                                        </td>
                                                    </tr>
                                                );
                                            }) : (
                                                <tr>
                                                    <td colSpan={7} className="text-center text-muted py-4">
                                                        {loading ? "Cargando…" : "No hay liquidaciones con los filtros aplicados"}
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>

            {modalAnular.visible && (
                <div className="modal fade show d-block" tabIndex="-1" role="dialog" style={{ background: "rgba(15,23,42,0.45)" }}>
                    <div className="modal-dialog modal-dialog-centered" role="document">
                        <div className="modal-content" style={{ borderRadius: "12px" }}>
                            <div className="modal-header py-2">
                                <h5 className="modal-title mb-0">
                                    Anular Liquidación
                                </h5>
                                <button type="button" className="close" onClick={cerrarModalAnular} disabled={anulando}>
                                    <span>&times;</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                <div className="small mb-3 liq-anular-resumen">
                                    <div><span className="text-muted">Profesional:</span> <strong>{modalAnular.row?.profesional_nombre}</strong></div>
                                    <div><span className="text-muted">Período:</span> <strong>{textoPeriodoLiquidacion(modalAnular.row)}</strong></div>
                                </div>
                                <div className="form-group mb-3">
                                    <label htmlFor="fechaAnulacion">Fecha de Anulación</label>
                                    <input
                                        id="fechaAnulacion"
                                        type="date"
                                        className="form-control form-control-sm"
                                        value={fechaAnulacion}
                                        onChange={(e) => setFechaAnulacion(e.target.value)}
                                        disabled={anulando}
                                    />
                                </div>
                                <div className="form-group mb-0">
                                    <label htmlFor="motivoAnulacion">Motivo de Anulación *</label>
                                    <textarea
                                        id="motivoAnulacion"
                                        className="form-control form-control-sm"
                                        rows={3}
                                        maxLength={2000}
                                        placeholder="Describa el motivo…"
                                        value={motivoAnulacion}
                                        onChange={(e) => setMotivoAnulacion(e.target.value)}
                                        disabled={anulando}
                                    />
                                </div>
                            </div>
                            <div className="modal-footer py-2">
                                <button type="button" className="btn btn-secondary btn-sm" onClick={cerrarModalAnular} disabled={anulando}>
                                    Cancelar
                                </button>
                                <button type="button" className="btn btn-danger btn-sm" onClick={confirmarAnular} disabled={anulando}>
                                    {anulando ? "Anulando…" : "Confirmar anulación"}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            <ModalLiquidacionHonorarios
                visible={modalImpresion.visible}
                data={modalImpresion.data}
                client={client}
                generandoDoc={generandoDoc}
                onClose={() => setModalImpresion({ visible: false, data: null })}
                onGenerarEgreso={() => navegarConProveedorLiquidacion("/crear-egreso", modalImpresion.data)}
                onGenerarDocumentoSoporte={() => navegarConProveedorLiquidacion("/crear-documento-soporte", modalImpresion.data)}
            />

            <Modal show={modalAcciones.visible} onHide={cerrarModalAcciones} centered dialogClassName="patient-actions-modal">
                <Modal.Header className="patient-actions-modal__header">
                    <Modal.Title className="patient-actions-modal__title">
                        <span className="patient-actions-modal__title-icon">
                            <i className="fas fa-file-invoice-dollar"></i>
                        </span>
                        Acciones de liquidación
                    </Modal.Title>
                    <button type="button" className="patient-actions-modal__close" onClick={cerrarModalAcciones}>
                        <i className="fas fa-times"></i>
                    </button>
                </Modal.Header>
                <Modal.Body className="patient-actions-modal__body">
                    {modalAcciones.row && (
                        <>
                            <div className="patient-actions-modal__patient">
                                <span className="patient-actions-modal__avatar">
                                    {(modalAcciones.row.profesional_nombre || "L").trim().charAt(0).toUpperCase()}
                                </span>
                                <div>
                                    <div className="patient-actions-modal__patient-name">{modalAcciones.row.profesional_nombre}</div>
                                    <div className="patient-actions-modal__patient-doc">
                                        {textoPeriodoLiquidacion(modalAcciones.row)} · {formatearMoneda(modalAcciones.row.valor_total)}
                                    </div>
                                </div>
                            </div>
                            <div className="d-flex flex-column" style={{ gap: "9px" }}>
                                <button type="button" className="btn patient-modal-action patient-modal-action--wallet" onClick={accionImprimir} disabled={generandoDoc}>
                                    <i className="fas fa-print mr-2"></i>
                                    Imprimir
                                </button>
                                {modalAcciones.row.estado !== "anulada" && (
                                    <>
                                        <button
                                            type="button"
                                            className="btn patient-modal-action patient-modal-action--wallet"
                                            onClick={accionGenerarEgreso}
                                            disabled={generandoDoc}
                                        >
                                            <i className="fas fa-money-bill-wave mr-2"></i>
                                            {generandoDoc ? "Preparando…" : "Crear Egreso"}
                                        </button>
                                        <button
                                            type="button"
                                            className="btn patient-modal-action patient-modal-action--wallet"
                                            onClick={accionGenerarDocumentoSoporte}
                                            disabled={generandoDoc}
                                        >
                                            <i className="fas fa-file-invoice mr-2"></i>
                                            {generandoDoc ? "Preparando…" : "Crear Documento Soporte"}
                                        </button>
                                        <button type="button" className="btn patient-modal-action patient-modal-action--care" onClick={accionAnular} disabled={generandoDoc}>
                                            <i className="fas fa-ban mr-2"></i>
                                            Anular
                                        </button>
                                    </>
                                )}
                            </div>
                        </>
                    )}
                </Modal.Body>
            </Modal>

            <Footer showToast={false} delay={0} />
            <style>{`
                .liq-prof-card { border: none; border-radius: 14px; box-shadow: 0 1px 3px rgba(15, 23, 42, 0.08); }
                .liq-prof-filters label {
                    display: block; font-size: 0.72rem; font-weight: 600; color: #6b7280;
                    text-transform: uppercase; letter-spacing: 0.03em; margin-bottom: 0.35rem;
                }
                .liq-prof-filters .form-control-sm { min-height: 34px; border-radius: 8px; }
                .liq-prof-table-card { border: none; border-radius: 14px; overflow: hidden; box-shadow: 0 1px 3px rgba(15, 23, 42, 0.08); }
                .custom-table thead th {
                    background: #f8f9fa; border-top: none; color: #7d7d7d; font-weight: 600;
                    text-transform: uppercase; font-size: 0.62rem; padding: 10px 8px;
                }
                .custom-table tbody td { padding: 8px 8px; vertical-align: middle; border-top: 1px solid #f0f0f0; font-size: 0.84rem; }
                .liq-motivo-cell { max-width: 220px; }
                .liq-motivo-cell span {
                    display: block; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;
                }
                .liq-icon-btn {
                    border: 1px solid transparent;
                    border-radius: 10px;
                    width: 31px;
                    height: 31px;
                    padding: 0;
                    display: inline-flex;
                    align-items: center;
                    justify-content: center;
                    transition: all .15s ease;
                }
                .liq-icon-btn i { font-size: 12px; }
                .liq-icon-btn--menu {
                    background: rgba(50, 58, 69, 0.1);
                    border-color: rgba(50, 58, 69, 0.18);
                    color: #2f3945;
                }
                .liq-icon-btn--menu:hover {
                    background: rgba(50, 58, 69, 0.16);
                    color: #202830;
                    transform: translateY(-1px);
                }
                .patient-actions-modal .modal-content {
                    border: none;
                    border-radius: 14px;
                    box-shadow: 0 18px 40px rgba(20, 33, 48, 0.28);
                    overflow: hidden;
                }
                .patient-actions-modal__header {
                    border-bottom: 1px solid #edf2f7;
                    padding: 12px 14px;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                }
                .patient-actions-modal__title {
                    display: flex;
                    align-items: center;
                    gap: 8px;
                    font-size: 1.1rem;
                    font-weight: 700;
                    color: #2b3440;
                }
                .patient-actions-modal__title-icon {
                    width: 28px;
                    height: 28px;
                    border-radius: 8px;
                    background: rgba(23, 162, 184, 0.13);
                    color: #148495;
                    display: inline-flex;
                    align-items: center;
                    justify-content: center;
                    font-size: 0.88rem;
                }
                .patient-actions-modal__close {
                    border: 0;
                    background: rgba(50, 58, 69, 0.08);
                    color: #4b5663;
                    width: 30px;
                    height: 30px;
                    border-radius: 8px;
                    display: inline-flex;
                    align-items: center;
                    justify-content: center;
                }
                .patient-actions-modal__close:hover {
                    background: rgba(50, 58, 69, 0.15);
                    color: #28313a;
                }
                .patient-actions-modal__body { padding: 14px; }
                .patient-actions-modal__patient {
                    display: flex;
                    align-items: center;
                    gap: 10px;
                    margin-bottom: 12px;
                    padding: 10px;
                    border-radius: 10px;
                    border: 1px solid #e8edf2;
                    background: #fafcfe;
                }
                .patient-actions-modal__avatar {
                    width: 34px;
                    height: 34px;
                    border-radius: 50%;
                    background: rgba(23, 162, 184, 0.16);
                    color: #147f90;
                    display: inline-flex;
                    align-items: center;
                    justify-content: center;
                    font-weight: 700;
                }
                .patient-actions-modal__patient-name {
                    font-size: 0.9rem;
                    font-weight: 700;
                    color: #2e3742;
                    line-height: 1.2;
                }
                .patient-actions-modal__patient-doc {
                    font-size: 0.76rem;
                    color: #6f7d8b;
                    margin-top: 2px;
                }
                .patient-modal-action {
                    border-radius: 12px;
                    font-weight: 700;
                    text-align: left;
                    border: 1px solid transparent;
                    min-height: 42px;
                    transition: all .16s ease;
                    background: transparent;
                    color: #47525e;
                }
                .patient-modal-action:hover {
                    transform: translateY(-1px);
                    box-shadow: none;
                    background: rgba(50, 58, 69, 0.07);
                    border-color: rgba(50, 58, 69, 0.08);
                }
                .patient-modal-action--wallet:hover { color: #0f7281; }
                .patient-modal-action--care:hover { color: #b91c1c; }
                .patient-modal-action--wallet i { color: #11a0b4; }
                .patient-modal-action--care i { color: #dc2626; }
            `}</style>
        </div>
    );
}

export default ListadoLiquidacionProfesional;
